import { useTranslate } from '@tolgee/react';
import Link from 'next/link';
import { fromUnixTime } from 'date-fns';
import { ContractFragment } from '@amf/shared/types/graphql';
import FormattedDate from '@amf/shared/components/utils/FormattedDate';

type Props = {
  contract: ContractFragment;
  prefixes: {
    player: string;
    team: string;
  };
};

function Contract({ contract, prefixes }: Props) {
  const { t } = useTranslate();
  const dateCreated = fromUnixTime(contract.dateCreated);

  return (
    <div className='Contract'>
      <div className='Contract__header'>
        <h3 className='Contract__type'>{t(`contracts.type.${contract.contractType}`)}</h3>
        <FormattedDate date={dateCreated} format='dd.MM.yyyy' className='Contract__date' />
      </div>
      <div className='Contract__player'>
        {contract.team && (
          <div className='Contract__playerSection'>
            <label className='Contract__playerLabel'>{t('contracts.team')}</label>
            <strong className='Contract__playerValue'>
              <Link href={`${prefixes.team}/${contract.team.id}`}>
                <a>{contract.team.name}</a>
              </Link>
            </strong>
          </div>
        )}
        {!contract.team && contract.player && (
          <div className='Contract__playerSection'>
            <label className='Contract__playerLabel'>{t('contracts.player')}</label>
            <strong className='Contract__playerValue'>
              <Link href={`${prefixes.player}/${contract.player.id}`} passHref>
                <a>{contract.player.fullName}</a>
              </Link>
            </strong>
          </div>
        )}
        {!contract.team && !contract.player && contract.name && (
          <div className='Contract__playerSection'>
            <label className='Contract__playerLabel'>{t('contracts.player')}</label>
            <strong className='Contract__playerValue'>{contract.name}</strong>
          </div>
        )}
        {contract.phone && (
          <div className='Contract__playerSection'>
            <label className='Contract__playerLabel'>{t('contracts.phone')}</label>
            <strong className='Contract__playerValue'>
              <a href={`tel:${contract.phone}`}>{contract.phone}</a>
            </strong>
          </div>
        )}
        {contract.email && (
          <div className='Contract__playerSection'>
            <label className='Contract__playerLabel'>{t('contracts.email')}</label>
            <strong className='Contract__playerValue'>
              <a href={`mailto:${contract.email}`}>{contract.email}</a>
            </strong>
          </div>
        )}
      </div>
      <p className='Contract__message'>{contract.message}</p>
    </div>
  );
}

export default Contract;
